import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'

export function useRemoveAssignee() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ itemId }: { itemId: string }) => {
      const response = await axios.put(`items/${itemId}`, {
        workflow_assignee_id: null,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['workflow-log'])
    },
  })
}
